import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Box } from '@mui/material'
import Link from 'next/link'
import noise from 'assets/images/noise.png'
import { unifiedColors } from 'styles/colors'
import { themeUtils } from 'styles/theme'

export const Background = styled(Box)`
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: ${unifiedColors.surface.blue};
`

export const NotFoundContainer = styled.div`
  align-items: center;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-width: 1440px;
  padding: 16px 24px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  ${themeUtils.maxWidth.md} {
    padding: 8px 0;
  }
`

interface NoiseBackgroundProps {
  blendMode?: boolean
}

export const NoiseBackground = styled.div<NoiseBackgroundProps>`
  background-image: url(${noise.src});
  transform: translate3d(0, 0, 0);
  ${({ blendMode }) =>
    blendMode
      ? css`
          mix-blend-mode: overlay;
        `
      : css`
          opacity: 0.03;
        `}

  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  background-repeat: repeat;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`

export const NotFoundCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 60px;
  flex: 1;
  z-index: 1;

  ${themeUtils.maxWidth.sm} {
    align-items: start;
    margin-bottom: 0;
  }
`

export const NotFoundSquare = styled.div`
  max-width: 610px;
  display: flex;
  padding: 4px 0px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 40px;
  padding: 40px;
  background: ${unifiedColors.surface.default};
  border: 35px solid ${unifiedColors.surface.blue};
  box-shadow: 35px 35px 0px ${unifiedColors.surface.blue};
  border-radius: 120px;

  ${themeUtils.maxWidth.md} {
    gap: 20px;
  }

  ${themeUtils.maxWidth.sm} {
    box-shadow: none;
    width: 90%;
    padding: 20px;
    border-radius: unset;
    background: none;
    border: none;
  }
`

export const NotFoundTitle = styled.h1`
  font-family: ${themeUtils.titleFont};
  line-height: 68px;
  white-space: pre-line;

  ${themeUtils.maxWidth.md} {
    line-height: 38px;
    font-size: 32px;
  }
`

export const NotFoundText = styled.p`
  font-family: ${themeUtils.bodyFont};
  font-weight: bold;

  ${themeUtils.maxWidth.md} {
    max-width: 300px;
  }
`

export const NotFoundLink = styled(Link)`
  color: ${unifiedColors.label.default};
`
